import Estimation from './components/Estimation/Estimation';
import { PriceGuideContainer } from './components/PriceGuideContainer/PriceGuideContainer';

export const PriceGuideEstimation = () => (
  <PriceGuideContainer>
    <Estimation />
  </PriceGuideContainer>
);
